var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRsLinkedinHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Login/RS Linkedin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98047 2.77002C4.18554 2.77002 2.73047 4.22509 2.73047 6.02002V18.02C2.73047 19.8149 4.18554 21.27 5.98047 21.27H17.9805C19.7754 21.27 21.2305 19.8149 21.2305 18.02V6.02002C21.2305 4.22509 19.7754 2.77002 17.9805 2.77002H5.98047ZM1.23047 6.02002C1.23047 3.39667 3.35712 1.27002 5.98047 1.27002H17.9805C20.6038 1.27002 22.7305 3.39667 22.7305 6.02002V18.02C22.7305 20.6434 20.6038 22.77 17.9805 22.77H5.98047C3.35712 22.77 1.23047 20.6434 1.23047 18.02V6.02002Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41046 10.4C7.82468 10.4 8.16046 10.7358 8.16046 11.15V16.69C8.16046 17.1042 7.82468 17.44 7.41046 17.44C6.99625 17.44 6.66046 17.1042 6.66046 16.69V11.15C6.66046 10.7358 6.99625 10.4 7.41046 10.4Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0505 10.4C11.4647 10.4 11.8005 10.7358 11.8005 11.15V16.69C11.8005 17.1042 11.4647 17.44 11.0505 17.44C10.6363 17.44 10.3005 17.1042 10.3005 16.69V11.15C10.3005 10.7358 10.6363 10.4 11.0505 10.4Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0005 11.9C12.7847 11.9 11.8005 12.8842 11.8005 14.1V16.69C11.8005 17.1042 11.4647 17.44 11.0505 17.44C10.6363 17.44 10.3005 17.1042 10.3005 16.69V14.1C10.3005 12.0558 11.9563 10.4 14.0005 10.4C16.0447 10.4 17.7005 12.0558 17.7005 14.1V16.69C17.7005 17.1042 17.3647 17.44 16.9505 17.44C16.5363 17.44 16.2005 17.1042 16.2005 16.69V14.1C16.2005 12.8842 15.2163 11.9 14.0005 11.9Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41046 7.04999C7.82468 7.04999 8.16046 7.38577 8.16046 7.79999V8.79999C8.16046 9.2142 7.82468 9.54999 7.41046 9.54999C6.99625 9.54999 6.66046 9.2142 6.66046 8.79999V7.79999C6.66046 7.38577 6.99625 7.04999 7.41046 7.04999Z",
    fill: "#FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsLinkedinHover);
export default __webpack_public_path__ + "static/media/RSLinkedinHOVER.a28df8cf6edbe8f1438c37c6689f1110.svg";
export { ForwardRef as ReactComponent };